export default __webpack_public_path__ + "static/media/rock1.bdc7766e.jpg";